import { createSelector } from 'reselect';
import lodash from 'lodash';

export const documentActionsSelector = state => state.documentActions;
export const usersByIdSelector = state => state.users;
export const userSelector = (state, userId) => lodash.get(state, ['users', userId], {} );
export const userFromInstitutionsSelector = (state, institutionId, userId) => lodash.get(state, ['institutions', 'byId', institutionId , 'users', userId], {} );
export const usersFromInstitutionsSelector = (state, institutionId) => lodash.get(state, ['institutions', 'byId', institutionId , 'users'], []);


export const usersListSelector = createSelector(
    usersByIdSelector,
    usersById => lodash.map(usersById, key => key)
);

